import { render, staticRenderFns } from "./RestriccionesAgregarPagination.vue?vue&type=template&id=442a51ee&"
import script from "./RestriccionesAgregarPagination.vue?vue&type=script&lang=js&"
export * from "./RestriccionesAgregarPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports